import { Component } from '@angular/core';
import { LoginComponent } from './components/login-component/login-component';
import { AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-auth',
  imports: [LoginComponent,CommonModule],
  templateUrl: './auth.html',
  styleUrl: './auth.scss'
})

export class Auth implements AfterViewInit{
  randomIcons: {
    src: string;
    top: string;
    left: string;
    rotate: number;
    scale: number;
  }[] = [];

  icons: string[] = [
    "/assets/icons/cinema_icon_camera.png",
    "/assets/icons/cinema_icon_door.png",
    "/assets/icons/cinema_icon_entry.png",
    "/assets/icons/cinema_icon_frame.png",
    "/assets/icons/cinema_icon_gogles.png",
    "/assets/icons/cinema_icon_popcorn.png",
    "/assets/icons/cinema_icon_reel.png",
    "/assets/icons/cinema_icon_ticket.png",
  ]
  constructor(){}

  ngAfterViewInit(): void {
    this.generateIcons();
  }

  generateIcons() {
    this.randomIcons = Array.from({ length: 50 }, () => {
      const index = Math.floor(Math.random() * this.icons.length);
      return {
        src: this.icons[index],
        top: `${Math.random() * 90}%`,
        left: `${Math.random() * 90}%`,
        rotate: Math.random() * 360,
        scale: 0.5 + Math.random() * 2.5
      };
    });
  }
}
